import client from "./client";

export const fetchWebsitePage = (key, options = {}) =>
  client.get(`/website/pages/${key}`, options);

export const fetchWebsiteConfig = (options = {}) =>
  client.get("/website/config", options);

export const fetchApprovedTourOperators = (options = {}) =>
  client.get("/website/tour-operators", {
    browserCache: "no-cache",
    ...options,
  });

export const downloadApprovedTourOperatorsExcel = (options = {}) =>
  client.get("/website/tour-operators/export.xlsx", {
    responseType: "blob",
    browserCache: "no-cache",
    ...options,
  });

export const resolveWebsiteContentPath = (path, options = {}) => {
  const query = new URLSearchParams({ path: String(path || "") }).toString();
  return client.get(`/website/content/resolve?${query}`, options);
};

export const fetchWebsiteContentPreview = (token, options = {}) =>
  client.get(`/website/content/preview/${encodeURIComponent(String(token || ""))}`, options);

export const fetchWebsiteContentExploreLanding = (options = {}) =>
  client.get("/website/content/explore-landing", options);

export const fetchWebsiteNoticeHomeFeed = (params = {}, options = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    searchParams.set(key, value);
  });
  const suffix = searchParams.toString() ? `?${searchParams.toString()}` : "";
  return client.get(`/website/notices/home-feed${suffix}`, options);
};
